<template>
  <div>
    <div v-if="emailToBeConfirm === false">
      <login-se v-if="isSeUrl() === true"></login-se>
      <div class="login-container" v-else>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center m-b-md">
              <h3>{{ $t('signIn.title') }}</h3>
              <small>{{ $t('signIn.sub_title') }}</small>
            </div>
            <div class="hpanel">
              <div class="panel-body">
                <form v-on:submit="login" action="#" method="post" id="loginForm">
                  <div class="form-group">
                    <label class="control-label required" for="email">{{ $t('signIn.form_email.label') }}</label>
                    <input v-model="email" type="text" v-bind:placeholder="$t('signIn.form_email.place_holder')"
                           v-bind:title="$t('signIn.form_email.title')" required value="" name="email" id="email"
                           class="form-control">
                  </div>
                  <div class="form-group">
                    <label class="control-label required" for="password">{{ $t('signIn.form_password.label') }}</label>
                    <input v-model="password" type="password" v-bind:title="$t('signIn.form_password.title')"
                           v-bind:placeholder="$t('signIn.form_password.place_holder')" required value="" name="password"
                           id="password" class="form-control" autocomplete="false">
                  </div>

                  <div v-if="errorLogin !== null" class="alert alert-danger" style="margin: 10px 0">
                    {{errorLogin}}
                  </div>

                  <div class="checkbox checkbox-info">
                    <input type="checkbox" checked id="rememberMe" v-model="rememberMe">
                    <label for="rememberMe">{{ $t('signIn.form_remember.label') }}</label>
                    <p class="help-block small hide">({{ $t('signIn.form_remember.help_block') }})</p>
                  </div>

                  <div v-if="accountExpired" class="m-t-sm m-b-sm alert alert-danger text-center">
                    <div class="m-t-xs m-b-xs">Your account has expired!</div>
                    <div>You can reactivate it by contacting us at <a href="mailto:sales@idexlab.com">sales@idexlab.com.</a></div>
                  </div>
                  <div class="row">
                    <div class="col-sm-2 col-xs-12 m-b-xs"></div>
                    <div class="col-sm-8 col-xs-12 m-b-xs">
                      <vue-ladda type="submit" :loading="submitLogin.loading" class="btn btn-info btn-block m-t-xs" :data-style="submitLogin.dataStyle">{{ $t('signIn.form.login') }}</vue-ladda>
                    </div>
                  </div>
                  <div class="text-center" style="margin-top: 10px">
                    <router-link :to="{name: 'ForgotPassword'}" class="text-info">Forgot password</router-link>
                  </div>
                  <div class="dividerWrapper m-b-md"><div class="dividerContent">or connect with</div></div>
                  <div class="row text-center">
                    <div class="m-b-sm col-sm-2 col-xs-12">
                    </div>
                    <div class="m-b-sm col-sm-2 col-xs-12">
                      <router-link class="btn btn-info btn-lg  btn-outline"  title="Linkedin" :to="{name: 'SsoConnection', params: {provider: 'linkedin'}}"><i class="fab fa-linkedin-in"></i></router-link>
                    </div>
                    <div class="m-b-sm col-sm-2 col-xs-12">
                      <router-link class="btn btn-info btn-lg  btn-outline" title="Google" :to="{name: 'SsoConnection', params: {provider: 'google'}}"><i class="fab fa-google"></i></router-link>
                    </div>
                    <div class="m-b-sm col-sm-2 col-xs-12">
                      <router-link class="btn btn-info btn-lg  btn-outline" title="Facebook" :to="{name: 'SsoConnection', params: {provider: 'facebook'}}"><i class="fab fa-facebook-square text-info"></i></router-link>
                    </div>
                    <div class="m-b-sm col-sm-2 col-xs-12">
                      <router-link class="btn btn-info btn-lg  btn-outline" title="Microsoft" :to="{name: 'SsoConnection', params: {provider: 'azure'}}"><i class="fab fa-brands fa-microsoft text-info"></i></router-link>
                    </div>
                    <div class="m-b-sm col-sm-2 col-xs-12">
                    </div>
                  </div>
                  <div class="dividerWrapper m-b-md"><div class="dividerContent">New user ?</div></div>
                  <div class="row">
                    <div class="col-sm-2 col-xs-12"></div>
                    <div class="col-sm-8 col-xs-12">
                      <router-link :to="{name: 'Register'}" class="btn btn-info btn-block">{{ $t('signIn.form.register') }}</router-link>
                    </div>
                  </div>
                  <div class="hide" style="text-align: right;margin-top: 10px">
                    <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <strong><a href="https://www.idexlab.com" target="_blank"> IDEXLAB</a></strong><br/> {{year}} Copyright Idexlab
          </div>
        </div>
      </div>

    </div>
    <div v-else>
      <enable-account v-bind:email="email"/>
    </div>
  </div>
</template>
<style scoped>

  .dividerWrapper {
    width: 100%;
    height: 20px;
    border-bottom: 1px solid #eaeaea;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

  }
  .dividerContent {
    background-color: #fff;
    padding: 0 20px;
    margin-top: 1em;
  }
  #loginForm label.required:after{
    content: none;
    color: inherit;
  }
</style>

<script>

import EnableAccount from './EnableAccount'
import VueLadda from 'vue-ladda'
import LoginSe from '../../components/login/loginSE'

export default {
  components: {EnableAccount, VueLadda, LoginSe},
  name: 'Login',
  methods: {
    login: function (event) {
      event.preventDefault()
      this.submitLogin.loading = true

      this.$auth.login({
        data: {email: this.email.trim(), password: this.password, ip: this.ip},
        redirect: null,
        success: (response) => {
          this.$auth.token(null, response.data.access_token)
          this.submitLogin.loading = false
          localStorage.setItem('is_already_connect', 'true')
          this.$auth.user()

          this.redirectAfterLogin()

          this.$salesMachine.signIn()
        },
        error: (res) => {
          this.password = ''
          if (res.response.status === 400) {
            let errors = res.response.data.errors
            switch (res.response.data.code) {
              case 1:
                this.errorLogin = errors['email'][0]
                break
              case 2:
                this.errorLogin = errors['credentials'][0]
                break
              case 3:
                this.emailToBeConfirm = true
                break
              case 4:
                this.accountExpired = true
                break
            }
          }
          this.submitLogin.loading = false
        },
        rememberMe: this.rememberMe,
        fetchUser: true
      })
    },
    getUserIP: function () {
      this.axios.get('https://ipinfo.io/json')
        .then((response) => {
          if (typeof response.data.ip !== 'undefined' && typeof response.data.ip !== 'undefined' && response.data.ip !== null) {
            this.ip = response.data.ip
          }
        }).catch(function (error) {
        })
    },
    isSeUrl () {
      let urlSE = process.env.SE_URL
      return window.location.origin.indexOf(urlSE) !== -1
    },
    ssoConnexionError (resp) {
      if (resp.response && resp.response.status === 400) {
        switch (resp.response.data.code) {
          case 5:
            this.$notify({
              type: 'error',
              title: 'Oops, connexion failed !',
              content: ' Try again or use another method to connect',
              placement: 'bottom-right'
            })
            break
          case 4:
            this.accountExpired = true
            this.$notify({
              type: 'warning',
              title: 'Oops, your account has expired!',
              content: 'You can reactivate it by contacting us at sales@idexlab.com',
              placement: 'bottom-right'
            })
            break
        }
      }
    },
    redirectAfterLogin () {
      let goTo
      let redirect = localStorage.getItem('redirect')

      if (redirect !== null) {
        redirect = this.$user.isBasic() && redirect.indexOf('search/reference/') === -1 ? redirect.replace('search/', 'searchSimple/') : redirect
        localStorage.removeItem('redirect')
        goTo = {path: redirect}
      } else {
        let plan = localStorage.getItem('register_plan')
        if (plan && plan !== 'basic' && plan !== 'expert' && this.$user.isSme()) {
          goTo = {name: 'Plans'}
        } else if (this.$user.isSme() && this.$user.isBasic()) {
          goTo = {name: 'Start'}
        } else {
          goTo = {name: 'Dashboard', params: {}}
        }
      }
      this.$router.replace(goTo)
    }
  },
  beforeMount () {
    let redirect = this.$auth.redirect()
    if (redirect !== null && redirect.from.name !== 'Login' && redirect.from.name !== 'Register') {
      localStorage.setItem('redirect', redirect.from.fullPath)
    }

    this.email = (this.$route.query.email) ? this.$route.query.email : this.email
    this.getUserIP()
  },
  data () {
    return {
      email: typeof this.$route.params.email !== 'undefined' ? this.$route.params.email : '',
      password: '',
      ip: '',
      rememberMe: false,
      emailToBeConfirm: false,
      errorLogin: null,
      accountExpired: false,
      submitLogin: {
        loading: false,
        dataStyle: 'zoom-in'
      },
      year: new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/Login.vue